import axios from "axios";
import { useEffect, useState } from "react";
import iconBackArrow from "../../assets/icons/back-arrow-filled.svg";

import { AnimationData } from "../../assets/glb/animations";
import { getAnimationByTokens } from "../../utils/animationHandle";
import LibrasIcon from "../../assets/icons/libras-icon.svg";
import EmojiVeryBad from "../../assets/icons/emoji-very-bad.svg";
import EmojiBad from "../../assets/icons/emoji-bad.svg";
import EmojiNeutral from "../../assets/icons/emoji-neutral.svg";
import EmojiGood from "../../assets/icons/emoji-good.svg";
import EmojiGreat from "../../assets/icons/emoji-great.svg";
import { LibrasButtonMenu } from "../LibrasButtonMenu";
import { CameraModal } from "../CameraModal";
import { FileModal } from "../FileModal";
import {
  FeedBackMenuContainer,
  EmojiContainer,
  ConfirmButton,
  Container,
  CancelButton
} from "./styles";
import { SendVideo } from "../SendVideo";

interface FeedbackProps {
  setAnimation?: React.Dispatch<React.SetStateAction<AnimationData[]>>;
  onBack: () => void;
  scenarioName?: string;
  scenarioId?: number; 
}

export function Feedback({
  setAnimation,
  scenarioName,
  onBack,
  scenarioId
}: FeedbackProps) {
  const [content, setContent] = useState("");
  const [feedbackSent, setFeedbackSent] = useState(false);
  const [isMobile, setIsMobile] = useState <boolean>(false);
  const [selectedEmoji, setSelectedEmoji] = useState<number | null>(null);
  const [showCameraModal, setShowCameraModal] = useState(false);
  const [showFileModal, setShowFileModal] = useState(false);
  const [videoBlob, setVideoBlob] = useState<Blob | null>(null);
  const [loadingLibrasKey, setLoadingLibrasKey] = useState<"intro" | "sent" | null>(null);


  async function sendVideoReq(link: string, file: File) {
    try {
      const res = await fetch(link, {
        method: "PUT",
        body: file,
        headers: {
          "Content-Type": file.type,
        },
      });

      if (!res.ok) {
        throw new Error("Falha no envio do video");
      }

      setFeedbackSent(true);
    } catch (error) {
      console.error("Erro ao enviar vídeo:", error);
    }
  }

  function playLibrasWithLoading(key: "intro" | "sent", glosaText: string) {
    setLoadingLibrasKey(key);

    const handleStarted = () => {
      setLoadingLibrasKey(null);
      window.removeEventListener("LISA_ANIMATION_STARTED", handleStarted);
    };

    window.addEventListener("LISA_ANIMATION_STARTED", handleStarted, { once: true });

    window.dispatchEvent(new CustomEvent("LISA_INTERRUPT"));

    getAnimationByTokens(glosaText)
      .then((animations) => {
        if (setAnimation) {
          setAnimation(animations);
          window.dispatchEvent(new CustomEvent("LISA_RESUME"));
        }
      })
      .finally(() => {
        setLoadingLibrasKey(null);
      });
}


  async function sendFeedback(): Promise<void> {
    if (selectedEmoji === null) return;
    try {
      const path = process.env.REACT_APP_API_URL;

      const fileName =
        videoBlob instanceof File
          ? videoBlob.name
          : "gravacao.webm";

      const mimeType = videoBlob?.type ?? null;

      const data : any = {
        content: content,
        opinion: emojiList.at(selectedEmoji!)?.title,
        scenario_id: scenarioId,
      };

      if (videoBlob) {
        data.file_name = fileName;
        data.mimetype = mimeType;
      }

      const options = {
        method: "POST",
        url: `${path}/feedback`,
        headers: {
          "Content-Type": "application/json",
        },
          data,
      };

      return axios
        .create({withCredentials: true})
        .request(options)
        .then((response) => {
          if (videoBlob) {
            const file =
              videoBlob instanceof File
                ? videoBlob
                : new File(
                  [videoBlob],
                  fileName,
                  { type: mimeType ?? "video/webm" }
                );

            sendVideoReq(response.data.url, file);
          }
          else {
            setFeedbackSent(true);
          }
        });
    } catch (error) {
      console.error("Erro ao enviar email:", error);
    }
  }

  useEffect (()=> {
    const checkScreen =()=> {
      setIsMobile(window.innerWidth <769 )
    }
    checkScreen();
    window.addEventListener('resize',checkScreen)
    return ()=> window.removeEventListener('resize',checkScreen)  
  },[])

  function handleBack(){
    onBack();
  }

  const emojiList = [
    { src: EmojiVeryBad, alt: "Muito insatisfeito", title: "Muito insatisfeito" },
    { src: EmojiBad, alt: "Insatisfeito", title: "Insatisfeito" },
    { src: EmojiNeutral, alt: "Neutro", title: "Neutro" },
    { src: EmojiGood, alt: "Satisfeito", title: "Satisfeito" },
    { src: EmojiGreat, alt: "Muito satisfeito", title: "Muito satisfeito" },
  ];

  function handleEmojiClick(index: number) {
    setSelectedEmoji(index);
  }

  return (
    <Container>
      {!isMobile && (
      <div className="EmailInputHeader">
        <img className="hint" onClick={handleBack} data-hint="Voltar" data-hint-placement="bottom" src={iconBackArrow} alt="Ícone voltar" />
        <span>{scenarioName} / <u>Avaliação</u></span>
      </div>
      )}
      {!feedbackSent ? (
        <FeedBackMenuContainer>
          <div className="titleContainer">
            <div className="title">
              <span>Sua opinião é importante!</span>    
            <LibrasButtonMenu
              disabled={loadingLibrasKey === "intro"}
              onClick={() =>
                playLibrasWithLoading(
                  "intro",
                  "OPINIAO SEU IMPORTANTE VER BOLA_CL COMBINAR SEU EXPERIENCIA SATISFAÇÃO ESCOLHER SI QUER COMPLEMENTAR PODER GRAVAR ENVIAR SEU AJUDAR_2 IMPORTANTE"
                )
              }
            >
              {loadingLibrasKey === "intro" ? (
                <span className="btnSpinner" />
              ) : (
                <img src={LibrasIcon} alt="Ícone Libras" />
              )}
            </LibrasButtonMenu>

            </div>
            <span className="sub">
              Selecione na escala o seu nível de satisfação em relação às informações apresentadas.
            </span>
            <span className="sub">
                Caso queria complementar, também é possível gravar ou enviar um vídeo em Libras. Sua contribuição é muito importante!
            </span>
          </div>

              <EmojiContainer>
                {emojiList.map((emoji, idx) => (
                  <img
                    key={emoji.alt}
                    src={emoji.src}
                    alt={emoji.alt}
                    title={emoji.title}
                    onClick={() => handleEmojiClick(idx)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        handleEmojiClick(idx);
                      }
                    }}
                    style={{
                      border: selectedEmoji === idx ? "3px solid var(--blue)" : "3px solid transparent",
                      boxShadow: selectedEmoji === idx ? "0 0 0 4px rgba(0,123,255,0.15)" : "none",
                      transition: "transform 0.1s, box-shadow 0.2s",
                      transform: selectedEmoji === idx ? "scale(1.1)" : "scale(1)",
                      margin: "0 12px",
                    }}
                    tabIndex={4}
                  />
                ))}
              </EmojiContainer>

          <div className="sendEmailContainer">
            <div className="inputContainer">
              <input
                value={content}
                onChange={(event) => setContent(event.target.value)}
                type="content"
                id="content"
                placeholder="Escreva aqui seu comentário..."
                tabIndex={5}
              />
              <SendVideo 
                setVideoBlob={setVideoBlob}
              />
            </div>
          </div>
            <p
              style={{
                opacity: selectedEmoji === null ? 1: 0,
                cursor: selectedEmoji === null ? "not-allowed" : "pointer"
              }}
            >
            </p>

          <div className="buttonContainer">
            <CancelButton type="button" onClick={onBack} tabIndex={9}>
              Cancelar
            </CancelButton>
            
            <ConfirmButton 
              type="button" 
              onClick={sendFeedback}
              style={{
                opacity: selectedEmoji === null ? 0.5 : 1,
                cursor: selectedEmoji === null ? "not-allowed" : "pointer"
              }}
              tabIndex={10}
            >
              Enviar
            </ConfirmButton>
          </div>

          {showFileModal && (
            <FileModal onClose={() => setShowFileModal(false)} />
          )}
          {showCameraModal && (
            <CameraModal onClose={() => setShowCameraModal(false)} />
          )}
        </FeedBackMenuContainer>
      ) : (
        <FeedBackMenuContainer>
          <div className="titleContainer">
            <div className="title">
              <span>Enviado!</span>
              <LibrasButtonMenu
                className="librasButtonMenu"
                disabled={loadingLibrasKey === "sent"}
                onClick={() =>
                  playLibrasWithLoading(
                    "sent",
                    "JA ENVIAR SEU FEEDBACK IMPORTANTE VOCE AJUDAR_2 LISA MELHOR"
                  )
                }
              >
                {loadingLibrasKey === "sent" ? (
                  <span className="btnSpinner" />
                ) : (
                  <img src={LibrasIcon} alt="Ícone Libras" />
                )}
              </LibrasButtonMenu>
            </div>
            <span className="sub">
              Seu feedback é importante! Você ajudou a deixar a LISA ainda melhor.
            </span>
          </div>
        </FeedBackMenuContainer>
      )}
    </Container>
  );
}
